/* * 分类页面 * 作者：马军 */
<template>
  <div class="category-page">
    <!-- <div class="search-box">
      <SearchInputBox
        :isAutoSearch="true"
        @onHashChange="onHashChange"
      />
    </div> -->
    <div class="category-page-content">
      <div class="main-content">
        <div class="main-content-left">
          <ScrollView
            ref="scrollViewCategory"
            class="scroll-view-wrapper scroll-view-category tran"
            :probeType="1"
            :listenScroll="true"
            :bounce="false"
            :enableAutoRefresh="true"
          >
            <ul class="nav-left-ul">
              <li
                class="nav-left-li ellipsis"
                v-for="(item, index) in firstCateList"
                :key="index"
                :class="{ 'active-ele': index === categoryCurrentIndex }"
                @click="onClickCategory($event, item, index)"
                :clstag="'jr|keycount|8530052_classify_index_catefirst|' + item.itemFirstCateCd"
              >
                {{ item.itemFirstCateName }}
              </li>
            </ul>
          </ScrollView>
        </div>
        <div class="main-content-right">
          <ScrollView
            ref="scrollViewRight"
            class="scroll-view-wrapper scroll-view-right tran"
            :listenScroll="true"
            :bounce="false"
            :enableAutoRefresh="true"
            :data="subclassCateList"
          >
            <ul class="right-content-box">
              <li
                class="right-content-li"
                v-for="item in subclassCateList"
                :key="item.itemSecondCateCd"
                v-if="item.thirdCateList && item.thirdCateList.length"
              >
                <div class="right-title">{{ item.itemSecondCateName }}</div>
                <ul class="jrm-bfc right-content-ul">
                  <li
                    v-for="(thirdItem, index) in item.thirdCateList"
                    :key="thirdItem.itemThirdCateCd + index"
                    @click="onClickThird($event, item, thirdItem)"
                    :data-id="thirdItem.itemThirdCateCd"
                    :clstag="'jr|keycount|8530052_classify_index_catethird|' + thirdItem.itemThirdCateCd"
                  >
                    <p class="img-wrapper">
                      <img
                        v-lazy="thirdItem.barndNameFull"
                        alt
                        v-if="thirdItem.barndNameFull"
                      />
                      <span
                        v-else
                        class="img-empty"
                      ></span>
                    </p>
                    <p class="name-text ellipsis">{{ thirdItem.itemThirdCateName }}</p>
                  </li>
                </ul>
              </li>
            </ul>
          </ScrollView>
        </div>
      </div>
    </div>
    <Navigation
      ref="nav"
      v-if="!isJdNav && isSpecialChannel && showBottomNav === -1"
    />
  </div>
</template>

<script>
import ScrollView from '@/components/ScrollView.vue';
import Navigation from '@/buscomponents/Navigation.vue';
import SearchInputBox from '@/buscomponents/search/SearchInputBox.vue';
import request from '@/util/request';
import { genLinkBySSR, isJdNavFun, isMiniProgram } from '@/util/common';
import { shareInit } from '@/util/share';
import { toSearchPage } from '@/util/searchUtil';
import { messages } from '@/config';

export default {
  name: 'CategoryPage',
  components: {
    Navigation,
    SearchInputBox,
    ScrollView
  },
  data() {
    //来自融合页跳转
    let showBtnTab = $.fn.cookie('JDDX_MAIN_PAGE');

    return {
      showBottomNav: showBtnTab || -1,
      isJdNav: true,
      itemFirstCateCd: '',
      categoryCurrentIndex: 0,
      firstCateList: [],
      subclassCateList: [],
      isSpecialChannel: true
    };
  },
  methods: {
    onscroll(e) {
      console.log(e);
    },
    onClickThird(e, item, itemThird) {
      if (itemThird && itemThird.itemThirdCateName) {
        // toSearchPage({
        //   // 一级类目
        //   fcl: this.itemFirstCateCd,
        //   // 二级类目
        //   scl: item.itemSecondCateCd,
        //   // 三级类目
        //   tcl: itemThird.itemThirdCateCd,
        //   sk: itemThird.itemThirdCateName
        // });
        let word = encodeURIComponent(itemThird.itemThirdCateName) || '手机';
        window.location.href = `https://jddx.jd.com/m/search/result/mall.html?word=${word}&source=mall&from=mx`;
      }
    },
    onClickCategory(e, item, index) {
      console.log('category', item.name, e.target);
      this.categoryCurrentIndex = index;
      if (this.$refs && this.$refs.scrollViewCategory && this.$refs.scrollViewCategory.scroll && this.$refs.scrollViewCategory.scroll.maxScrollY < this.$refs.scrollViewCategory.scroll.y) {
        this.$refs.scrollViewCategory.scrollToElement(e.target, 800);
      }

      this.requestGetSubclassSearch({ itemFirstCateCd: item.itemFirstCateCd, itemFirstCateName: item.itemFirstCateName });
    },
    requestGetSubclassSearch({ itemFirstCateCd, itemFirstCateName }) {
      this.$loading.show();
      console.log(itemFirstCateName);
      this.itemFirstCateCd = itemFirstCateCd;
      request.getSubclassSearch({
        data: {
          itemFirstCateCd
        },
        success: ({ subclassCateList }) => {
          this.$loading.hide();

          if (subclassCateList && subclassCateList.length) {
            this.subclassCateList = subclassCateList;

            this.$nextTick(() => {
              if (this.$refs && this.$refs.scrollViewRight) {
                this.$refs.scrollViewRight.scrollTo(0, 0);
              }
            });
            if (process.env.VUE_APP_ENV === 'dev') {
              // console.clear();
              // subclassCateList.map(cate => {
              //   if (cate && cate.thirdCateList && cate.thirdCateList.length) {
              //     cate.thirdCateList.map(item => {
              //       console.log(itemFirstCateName, '\t', itemFirstCateCd, '\t', cate.itemSecondCateName, '\t', cate.itemSecondCateCd, '\t', item.itemThirdCateName, '\t', item.itemThirdCateCd);
              //     });
              //   }
              // });
            }
          }
        }
      });
    },
    shareInit() {
      try {
        const defaultOption = {
          shareURL: genLinkBySSR(),
          shareImgSrc: 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
          shareTitle: messages.shareTitle,
          shareDesc: messages.shareDesc,
          shareChannels: ['0', '1', '3']
        };

        shareInit(defaultOption);
      } catch (error) {
        console.log(error);
      }
    },
    onHashChange() {
      this.shareInit();
    }
  },
  created() {
    if (this.$route.query && this.$route.query.isSpecialChannel && this.$route.query.isSpecialChannel == 1) {
      this.isSpecialChannel = false;
    }
    this.shareInit();

    this.isJdNav = isJdNavFun(this.$route);
    if (isMiniProgram()) {
      this.isJdNav = true;
    }

    this.$loading.show();
    request.getFirstCateSearch({
      success: ({ firstCateList }) => {
        if (firstCateList && firstCateList.length) {
          if (firstCateList.sort) {
            firstCateList = firstCateList.sort((a, b) => {
              return a.id - b.id;
            });
          }

          this.firstCateList = firstCateList;

          this.requestGetSubclassSearch({ itemFirstCateCd: firstCateList[0].itemFirstCateCd, itemFirstCateName: firstCateList[0].itemFirstCateName });
        }
      }
    });
  },
  mounted() {
    // this.setTitle({ delayTime: 10 });
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss" scoped>
@import './../scss/mixin.scss';
$paddingBottom: $rem170;

.category-page {
  width: 100%;
  height: 100%;
  //   padding-top: $rem88 + $rem10;
  position: relative;

  .search-box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: $rem68 + $rem20;
    box-shadow: 0 4px 6px 0 rgba(38, 50, 71, 0.05);
  }

  .category-page-content {
    $main-content-left: $rem180;
    height: 100%;

    .main-content {
      position: relative;
      height: 100%;
      padding-left: $main-content-left;
    }

    .main-content-left {
      position: absolute;
      left: 0;
      top: 0;
      width: $main-content-left;
      height: 100%;
      background-color: #f2f2f2;

      .scroll-view-category {
        overflow: hidden;
      }
    }

    .nav-left-ul {
      padding-bottom: $paddingBottom;

      .nav-left-li {
        position: relative;
        padding: 0 $rem10;
        width: $rem180;
        height: $rem100;
        line-height: $rem100;
        text-align: center;

        &.active-ele {
          font-family: PingFangSC-Semibold;
          background-color: #fff;
        }
        &.active-ele:before {
          width: $rem8;
          height: $rem32;
          position: absolute;
          left: 0;
          top: $rem34;
          background-color: #c29451;
          content: '';
        }
      }
    }

    .main-content-right {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: #f9f9f9;
      overflow: hidden;

      .right-content-box {
        padding-bottom: $paddingBottom;

        .right-content-li {
          margin: 0 $rem32 $rem20 $rem20;
          background: #fff;
        }

        .right-title {
          font-family: PingFangSC-Semibold;
          padding: $rem30 0 $rem30 $rem20;
          font-size: $rem28;
          color: #222222;
          line-height: $rem28;
        }

        .right-content-ul {
          padding: $rem10;
          padding-bottom: $rem10;

          li {
            width: 32.8%;
            float: left;
            text-align: center;
            margin-bottom: $rem20;

            .img-wrapper {
              height: $rem140;
              text-align: center;
              overflow: hidden;
            }

            img,
            .img-empty {
              display: inline-block;
              width: $rem140;
              height: $rem140;
            }

            .name-text {
              margin-top: $rem18;
              font-size: $rem24;
              color: #333333;
              text-align: center;
              line-height: $rem28;
            }
          }
        }
      }
    }
  }
}
</style>
